module.exports = "/images/Miniature golf.svg?9d52449637464d21e9391fb85453ee3e";